import * as React from 'react'
import * as Tgcc from '../tgccGlobal'
import {browserHistory} from 'react-router'
import {connect} from 'react-redux'
import {CloseX} from '../Components/CloseX'
import * as Request from '../tgccRequest'
import Radium, { StyleRoot } from 'radium'
import {RealCampusHdr} from './RealCampusHdr';
import {RealCampusFeedback} from './RealCampusFeedback';



const boxStyle: React.CSSProperties = {
    height: '0px',
    width: '550px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginLeft: '-275px',
    padding: '20px',
    backgroundColor: 'white',
    fontFamily: 'CenturyGothic',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around'
};

const rowStyle: React.CSSProperties = {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
    height: '40px',
    alignItems: 'center'
}

const lblStyle: React.CSSProperties = {
    color: Tgcc.Styles.darkTextColor,
    height: '25px',
    lineHeight: '25px',
    fontSize: '18px',
    marginRight: '8px',
    display: 'flex',
    flex: '1 1 0px',
    fontFamily:'BarlowMedium',
    '@media (max-width:320px)': {
        fontSize:'12px'
    }
}

const inputStyle: React.CSSProperties = {
    backgroundColor: 'white',
    height: '25px',
    lineHeight: '25px',
    padding: '0 4px',
    fontSize: '16px',
    display: 'flex',
    margin: '2px',
    border:'1px solid black',
    fontFamily:'BarlowLight'
}

const selectStyle: React.CSSProperties = {
    backgroundColor:'white',
    height:'25px',
    fontFamily:'BarlowLight',
    border:'1px solid black'
}
const checkboxStyle: React.CSSProperties = {
    width:'20px',
    height:'20px',
    backgroundColor:'white',
    border:'1px solid black'
}
const stateStyle: React.CSSProperties = {
    backgroundColor:'white',
    width:'25px',
    border:'1px solid black',
    fontFamily:'BarlowLight'
}
const zipStyle: React.CSSProperties = {
    backgroundColor:'white',
    width:'100px',
    border:'1px solid black',
    fontFamily:'BarlowLight'
}
const cityStyle: React.CSSProperties = {
    backgroundColor:'white',
    width:'250px',
    border:'1px solid black',
    fontFamily:'BarlowLight'
}
const phoneStyle: React.CSSProperties = {
    backgroundColor:'white',
    width: '250px',
    border:'1px solid black',
    fontFamily:'BarlowLight'
}
const smsStyle: React.CSSProperties = {
    width:'20px',
    height:'20px',
    backgroundColor:'white',
    border:'1px solid black'
}
const loginCust: React.CSSProperties = {
    textAlign:'center',
    color:'#5E6A74',
    fontFamily:'BarlowMedium',
    fontSize:'20px'
}
const loginBtn: React.CSSProperties = {
    cursor:'pointer',
    color:'blue'
}
const registerBox: React.CSSProperties = {
    marginTop:'0px',
    height: '600px',
    width: '50%',
    padding: '20px',
    fontFamily: 'BarlowMedium',
    textTransform: 'uppercase',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
}
const dashHdrLine: React.CSSProperties = {
    width:'284px',
    backgroundColor:'#E9E6E6',
    height:'2px',
    display:'inline-block'
}
const innerBox: React.CSSProperties = {
    backgroundColor:'white',
    padding:'10px',
    display:'flex',
    flexDirection:'column',
    width:'75%',
    alignSelf:'center'
}
const submitBtn:React.CSSProperties = {
    border: '1px solid transparent',
    backgroundColor: '#5E6A74',
    height: '40px',
    lineHeight: '35px',
    fontSize: '15px',
    padding: '0 25px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: 'white',
    alignSelf: 'center',
    cursor: 'pointer',
    margin: '10px auto',
    width:'142px',
    fontFamily:'Reitam'
}

const container: React.CSSProperties = {
    minHeight:'800px',
}
const registerImg: React.CSSProperties = {
    backgroundImage:'url(' + Tgcc.ResolveUrl('~/images/Social_3.png') + ')',
    width:'50%',
    backgroundRepeat:'no-repeat',
    backgroundSize:'cover',
    height:'600px'
}

const registerDiv: React.CSSProperties = {
    display:'flex'
}


let nameStyle = Object.assign({}, inputStyle, {width: '137px', textTransform: 'capitalize','@media(max-width:320px)':{width:'110px'}});
let pwdStyle = Object.assign({}, inputStyle, {width: '115px','@media(max-width:320px)': {width:'98px'}});
let emailStyle = Object.assign({}, inputStyle, {width: '278px','@media (max-width:320px)': {width:'210px'}});
let addressStyle = Object.assign({}, inputStyle, {width: '300px'});
let orgStyle = Object.assign({},inputStyle,{width:'300px'});
let schOrBusStyle = Object.assign({},inputStyle,{width:'300px'});

class _RealCampusRegister extends React.Component<Tgcc.BaseProps, any> {
    state: any = {
        error: "",
        email: "",
        password: "",
        confirmpassword: "",
        firstName: "",
        lastName: "",
        isWaiting: false,
        Schools:null,
        school:null,
        isCollegiate:false,
        org: null,
        address: null,
        city:null,
        St:null,
        zip:null,
        phone:null,
        smsAllowed: true,
        group:null,
        buyer:"No",
        isBuyer:false,
        studentGroup: null,
        type:"Real Campus"
    };

    componentWillMount() {
        this.clearState();
        Request.getSchools((schools : string[]) => this.SchoolsLoaded(schools));
        console.log(this.state.type);
    }
    componentDidMount(){
        var tag = document.getElementById('register');
        tag.scrollIntoView(false);
    }
    
    scrollPageToView = (id: string) => {
        var el = document.getElementById(id);
        var scroller = document.getElementById("Scroller");
        scroller.scrollTop = el.offsetTop - 75;
    }

    SchoolsLoaded(schools : string[]) {
        this.setState({Schools: schools});
    }
    clearState = () => {
        this.setState({Schools: null,school:null,isCollegiate:false,Orgs:null,org:null});       
    }

    failedLogin = (err: any) => {
        this.setState({error: "registration succeeded, but login failed", isWaiting: false});
    }
    

    succesfulRegistration = (userData: Tgcc.UserInfo) => {
        this.props.dispatch({type: Tgcc.StateAction.SetUserInfo, payload: userData});
        this.setState({isWaiting:false});
        Request.loginUser(this.state.email, 
            this.state.password, 
            (ld: Tgcc.LoginData)=>{ Tgcc.successfulCampusLogin(this.props.dispatch, ld); },
            this.failedLogin);
    }
    getSchools() {
        var schools = new Array();
        for (var i in this.state.Schools) {
            var cat: string = this.state.Schools[i];
            schools.push(
                <option key={i} value={cat}>{cat}</option>
            )
        };
        return schools;
    }
    failedRegistration = (err: string) => {
        this.setState({error: err, isWaiting: false});
    }

    doRegistration = () => {
        
        if(!this.state.firstName || !this.state.firstName.trim())
            this.setState({error: 'First Name cannot be blank', isWaiting: false});
        else if(!this.state.lastName || !this.state.lastName.trim())
            this.setState({error: 'Last Name cannot be blank', isWaiting: false});
        else if(!this.state.email || !this.state.email.trim())
            this.setState({error: 'Email cannot be blank', isWaiting: false});
        else if(!this.state.address || !this.state.address.trim())
            this.setState({error: 'Address cannot be blank', isWaiting: false});
        else if(!this.state.city || !this.state.city.trim())
            this.setState({error: 'City cannot be blank', isWaiting: false});
        else if(!this.state.St || !this.state.St.trim())
            this.setState({error: 'State cannot be blank', isWaiting: false});
        else if(!this.state.zip || !this.state.zip.trim())
            this.setState({error: 'Zip code cannot be blank', isWaiting: false});
        else if(!this.state.phone || !this.state.phone.trim())
            this.setState({error: 'Phone cannot be blank', isWaiting: false});
        else if(!this.state.studentGroup || !this.state.studentGroup.trim())
            this.setState({error: 'Student Group cannot be blank', isWaiting: false});
        else if(!this.state.password || !this.state.password.trim())
            this.setState({error: 'Password cannot be blank', isWaiting: false});
        else if(this.state.password != this.state.confirmpassword)
            this.setState({error: 'Passwords do not match', isWaiting: false});
        else {
            this.setState({isWaiting: true});
            var user = new Tgcc.UserInfo;
            user.email = this.state.email;
            user.firstName = this.state.firstName;
            user.lastName = this.state.lastName;
            user.schoolOrBusiness = this.state.school;
            user.studentGroup = this.state.studentGroup
            user.organization = this.state.org;
            user.address = this.state.address;
            user.city = this.state.city;
            user.state = this.state.St;
            user.zip = this.state.zip;
            user.phone = this.state.phone;
            user.smsAllowed = this.state.smsAllowed;
            user.group = this.state.group;
            user.buyer = this.state.buyer;
            user.type = this.state.type; 
            Request.registerUser(user, 
                this.state.password, 
                this.state.confirmpassword,
                this.succesfulRegistration, 
                this.failedRegistration)           
                  
        }
    }

    fnameChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({firstName: evt.currentTarget.value});
    }
    lnameChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({lastName: evt.currentTarget.value});
    }
    emailChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({email: evt.currentTarget.value});
    }

    passwordChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({password: evt.currentTarget.value});
    }
    confirmpasswordChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        evt.stopPropagation();
        this.setState({confirmpassword: evt.currentTarget.value});
    }
    checkKeyPressed = (evt: React.KeyboardEvent<HTMLInputElement>) => {
        if(evt.key === 'Enter')
            this.doRegistration();
    }
    schoolChanged = (evt: React.FormEvent<HTMLSelectElement>) => {
        this.setState({school:evt.currentTarget.value})
    }
    companyChanged = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({school:evt.currentTarget.value})
    }
    orgChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({org:evt.currentTarget.value})
    }
    studentChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({studentGroup:evt.currentTarget.value})
    }
    grpSizeChg = (evt: React.FormEvent<HTMLSelectElement>) => {
        this.setState({group:evt.currentTarget.value})
    }
    addressChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({address:evt.currentTarget.value})
    }
    cityChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({city:evt.currentTarget.value})
    }
    stateChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({St:evt.currentTarget.value})
    }
    zipChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({zip:evt.currentTarget.value})
    }
    phoneNumberChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({phone:Tgcc.formatPhoneNumber(evt.currentTarget.value)});
    }
    smsAllowedChanged = (evt: React.FormEvent<HTMLInputElement>) => {
        this.setState({smsAllowed: evt.currentTarget.checked});
    }
    buyerChanged = (evt:React.FormEvent<HTMLInputElement>) => {
        this.setState({isBuyer:evt.currentTarget.checked});
        if(evt.currentTarget.checked){
            this.setState({buyer:'Yes'});
        } else {
            this.setState({buyer:'No'});
        }
    }
    openLogin = () =>{browserHistory.push(Tgcc.Routes.RealCampusLogin)}
    collegiateCheck(){
            return (<div>
                        <div style={rowStyle}>
                            <div style={lblStyle} className="registerLabels">School</div>
                                <select onChange={this.schoolChanged} name="school" style={selectStyle} className="registerSelect">
                                    {this.getSchools()}
                                </select>
                        </div>
                        <div style={rowStyle}>
                            <div style={lblStyle} className="registerGroup">Student Group</div>
                                <input type='text' style={orgStyle} onChange={this.studentChanged} name="studentGroup" placeholder="Wiffle Ball Club, Kappa Delta" onKeyPress={this.checkKeyPressed} />
                        </div>
                        <div style={rowStyle}>
                            <div style={lblStyle} className="registerLabels">Group Size</div>
                            <select onChange={this.grpSizeChg} name="group" style ={selectStyle}>
                                <option key={1} value={"1-23"}>1-23</option>
                                <option key={2} value="24-49">24-49</option>
                                <option key={3} value="50-99">50-99</option>
                                <option key={4} value="100-149">100-149</option>
                                <option key={5} value="150-299">150-299</option>
                                <option key={6} value="300+">300+</option>
                            </select>
                        </div>
                        <div style={rowStyle}>
                            <div style={lblStyle} className="collegiateCustomer">Are you the buyer?</div>
                            <input type="checkbox" className="checkboxStyle" style={checkboxStyle} onChange={this.buyerChanged} name="buyer" checked={this.state.isBuyer}/>
                        </div>
                   </div>)
    }
    render(){
        var btnElement = this.state.isWaiting ? 
            Tgcc.workingGif
            : <div style={submitBtn} onClick={this.doRegistration}>Submit</div>
        var collegiateDropDown = this.collegiateCheck();
       
        return(
            <div style={container}>
                <div id='register'></div>
                <RealCampusHdr />
                <div style={registerDiv} className="realRegDiv">
                    <div style={registerImg} className="realRegImg"></div>
                    <div style={registerBox} className='realRegister'>
                        <div style={loginCust}>Already a customer?&nbsp;&nbsp;&nbsp;<a style={loginBtn} className="hoverUnderline" onClick={this.openLogin}>login</a></div>

                            <div style={innerBox} className='realinsideRegister'>
                            <div style={Tgcc.Styles.error}>{this.state.error}</div>
                            <div style={rowStyle}>
                            <div style={lblStyle} className="registerLabels">Name</div>                        
                                <input autoFocus type='text'className='nameInput' style={nameStyle} name='firstName' onChange={this.fnameChanged} onKeyPress={this.checkKeyPressed} placeholder="first name"/>
                                <input type='text' className='nameInput'style={nameStyle} name='lastName' onChange={this.lnameChanged} onKeyPress={this.checkKeyPressed} placeholder="last name"/>
                            </div>
                        
                        {collegiateDropDown}
                            <div style={rowStyle}>
                                <div style={lblStyle} className="registerLabels">address</div>
                                <input type='text' style={addressStyle} name='Address' placeholder='shipping/mailing address' onChange={this.addressChanged}/>
                            </div>
                            <div style={rowStyle}>
                                <input type='text' style={cityStyle} name='City' placeholder='New York City' onChange={this.cityChanged}/>
                                <input type='text'  style={stateStyle} name='State' placeholder='ST'  onChange={this.stateChanged}/>
                                <input type='text' style={zipStyle} name='Zip' placeholder='90210' onChange={this.zipChanged}/>
                            </div>
                            <div style={rowStyle}>
                                <div style={lblStyle} className="registerLabels">phone#</div>
                                <input type='text' style={phoneStyle} name='Phone' placeholder='daytime phone number' onChange={this.phoneNumberChanged}/>
                            </div>
                            <div style={rowStyle}>
                                <div style={lblStyle} className="registerLabels">Receive text notifications?</div>
                                <input type='checkbox' style={smsStyle} name='smsAllowed' checked={this.state.smsAllowed} onChange={this.smsAllowedChanged}/>
                            </div>
                            <div style={rowStyle}>
                                <div style={lblStyle} className="registerLabels">Email</div>
                                <input type='text' style={emailStyle} name='email' onChange={this.emailChanged} onKeyPress={this.checkKeyPressed} placeholder="email for login"/>
                            </div>
                            <div style={rowStyle}>
                                <div style={lblStyle} className="registerLabels">Password</div>
                                <input type='password'  className='campusPasswordInput' style={pwdStyle} name='password' onChange={this.passwordChanged} onKeyPress={this.checkKeyPressed} placeholder="password"/>
                                <input type='password' className='campusPasswordInput' style={pwdStyle} name='convfirmpassword' onChange={this.confirmpasswordChanged} onKeyPress={this.checkKeyPressed} placeholder="confirm"/>
                            </div>              
                            {btnElement}
                            </div>
                        </div> 
                    </div>
                    <RealCampusFeedback state={this.props.state} />
                </div>              
        );
    }
}

const mapStateToProps = (state : Tgcc.GlobalState, ownState: any) => {
    return { state: state };
};

export var RealCampusRegister = connect(mapStateToProps)(Radium(_RealCampusRegister));